import React from "react";
import PropTypes from "prop-types";
import { isEqual } from "lodash";
import {
  OverlayView,
} from "react-google-maps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBolt } from "@fortawesome/free-solid-svg-icons";
import { labelItems } from "./constants/map-filter-items";

class MapMarker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showInfo: false
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isEqual(nextProps.item, this.props.item)) {
      return true;
    } else if (nextProps.isSelected !== this.props.isSelected) {
      return true;
    } else if (nextState.showInfo !== this.state.showInfo) {
      return true;
    }
    return false;
  }

  render() {
    const {
      isSelected,
      item
    } = this.props;

    let styles = {
      boxShadow: "none",
      zIndex: 10
    };
    if (isSelected) {
      styles = {
        boxShadow: "0 0 25px 12px #008B00",
        zIndex: 1000
      };
    }

    const statusLabelItem = labelItems.find(i => i.value === item.status);
    const style = {
      backgroundColor: statusLabelItem ? statusLabelItem.color : "",
    };
    const speedMoreThen30 = this.props.bikeSpeed(item.condition) >= 30 ? "speed-limit" : "";

    return (
      <OverlayView
        position={{
          lat: item.position.coordinates[1],
          lng: item.position.coordinates[0]
        }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <div
          className="markerBikeBox"
          style={styles}
        >
          <div
            className={`markerBike ${speedMoreThen30}`}
            // onClick={() => this.props.showPositionFromMap(item)}
            onClick={() => this.setState({ showInfo: true })}
            style={style}
          >
            <div>{this.props.bikeSpeed(item.condition)}</div>

            {item.condition.charging && <FontAwesomeIcon
              icon={faBolt}
              className="position-absolute"
              style={{
                top: -8,
                right: 0,
                fontSize: 20,
                color: "blue"
              }}
            />}

            {item.condition && this.props.battery(item.condition)}
            {this.state.showInfo && (
              <div
                className="markerBikePopup"
                onClick={() => this.props.showPositionFromMap(item)}
                onMouseLeave={() => this.setState({ showInfo: false })}
              >
                <div>Bike ID: {item.id}</div>
                <div>QR: {item.qr}</div>
                <div>
                  <div>{this.props.progressBar(item.condition)}</div>
                  <div className="d-flex justify-content-around">
                    <span>{this.props.onCharge(item.condition)}</span>
                    <span>{this.props.onGps(item.condition)}</span>
                    <span>{this.props.onLine(item.connected)}</span>
                    <span>{this.props.onLock(item.condition)}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </OverlayView>
    );
  }
}

MapMarker.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  item: PropTypes.object.isRequired
};

export default MapMarker;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/map-marker.js